import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AccessType, ComponentType, Progress, ProgressType, SummaryType } from '../enums/enum.type';
import { AccessDetails, ActualDetails, AddTest, AllocateMatiObj, CommentObj, ControlFieldFarmer, ControlFieldJson, ControlFieldUpdateComment, DefectNoc, FarmerDeploymentNOC, FarmerDetails2, Id, PlanningDetails, PreSamplePlot, PreviousSampleLocationObj, QcReport, ReportData, RequestSource, SoilPHDetails, TrailerDetails, UpdateBulkFarmerData, UpdateBulkFarmerPh, UpdateEngagementData, UpdateFarmerDeployment, UpdateFarmerQualification, UpdateSourceObj, UploadCertificate, VerificationObjForSource } from '../models/models';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class GetDataService {

  constructor(private http:HttpClient,private cookieService: CookieService){
    const accessType = localStorage.getItem('access_type') && localStorage.getItem('access_type')=='View'?AccessType.View:AccessType.Edit;
    
    if(accessType == AccessType.Edit){
      const farmAccess = localStorage.getItem('farm_access') && localStorage.getItem('farm_access') == 'true'?true:false;
      const warehouseAccess = localStorage.getItem('warehouse_access') && localStorage.getItem('warehouse_access') == 'true'?true:false;
      const supplyDemandAccess = localStorage.getItem('supply_demand_access') && localStorage.getItem('supply_demand_access') == 'true'?true:false;
      const labAppAccess = localStorage.getItem('lab_app_access') && localStorage.getItem('lab_app_access') == 'true'?true:false;
      this.setAccessDetails({accessType:AccessType.Edit,farmAccess:farmAccess,warehouseAccess:warehouseAccess,supplyDemandAccess:supplyDemandAccess,labAppAccess:labAppAccess});
    }
    else{
      this.setAccessDetails({accessType:AccessType.View,farmAccess:false,warehouseAccess:false,supplyDemandAccess:false,labAppAccess:false});
    }
  }

  private _accessDetails = new BehaviorSubject<AccessDetails>({accessType:AccessType.View,farmAccess:false,warehouseAccess:false,supplyDemandAccess:false,labAppAccess:false});
  setAccessDetails = (accessDetails:AccessDetails) =>{
    this._accessDetails.next(accessDetails);
  }

  getAccessDetails = () =>{
    return this._accessDetails.asObservable();
  }
  
  private _username = new BehaviorSubject<any>(localStorage.getItem('mati_admin_username'));
  componentType = new BehaviorSubject<ComponentType>(ComponentType.dashboard);

  switchBasePopup = new BehaviorSubject<boolean>(false);

  // private _accessType = new BehaviorSubject<AccessType>(AccessType.View);
  // private _farmAccess = new BehaviorSubject<Boolean>(false);
  // private _warehouseAccess = new BehaviorSubject<Boolean>(false);
  // private _supplyDemanAccess = new BehaviorSubject<Boolean>(false);

  // setAccessType = (accessType:AccessType) =>{
  //   this._accessType.next(accessType);
  // }

  // setFarmAcess =(access:boolean)=>{
  //   this._farmAccess.next(true);
  // }
  // setWarehouseAccess =(access:boolean)=>{
  //   this._warehouseAccess.next(true);
  // }

  // setSupplyDemandAccess =(access:boolean)=>{
  //   this._supplyDemanAccess.next(true);
  // }



  // getAccessType = () =>{
  //   return this._accessType.asObservable();
  // }

  // getFarmAccess = () =>{
  //   return this._farmAccess.asObservable();
  // }
  // getWarehouseAccess = () =>{
  //   return this._warehouseAccess.asObservable();
  // }
  // getSupplyDemandAccess = () =>{
  //   return this._supplyDemanAccess.asObservable();
  // }
  searchBarPlaceholder = new BehaviorSubject<string>("");

  getUsername = () =>{
    const username = this._username.asObservable();
    return username;
  }

  setUsername = (value:string) =>{
    this._username.next(value);
  }

  getRestApiConnection() {
    return (environment.baseUrl);
  }
  getRestApiConnection2() {
    return (environment.baseUrl2);
  }
  getRestApiConnection3() {
    return (environment.baseUrl3);
  }
  checkAdminExistence =(email:string)=>{
    let params = new HttpParams();
    params = params.append('email', email);
    params = params.append('user_type', 'fr');
    return this.http.get<any>(this.getRestApiConnection() + '/admin/checkAdminExistence',{params: params});
  }

  getFarmerList = (qualificationStatus:-1|0|1|2,startDate:any,endDate:any,pageno:number,pageSize:number,villageIds?:number[]) =>{
    let params = new HttpParams();
    params = params.append('qualification_status', qualificationStatus.toString());
    params = villageIds && villageIds.length>0?params.append('village_id', JSON.stringify(villageIds)):params;
    if(startDate){
      params = params.append('startDate', startDate.toString());
    }
    if(endDate){
      params = params.append('endDate', endDate.toString());
    }
    params = params.append('pageSize', pageSize.toString());
    params = params.append('page', pageno.toString());
    return this.http.get<any>(this.getRestApiConnection() + '/adminFarmApp/getFarmerList',{params:params});
  }
  
  getSoilSampleDetails = (startDate:any,endDate:any,pageno:number,pageSize:number) =>{
    let params = new HttpParams(); 
    if(startDate){
      params = params.append('startDate', startDate.toString());
    }
    if(endDate){
      params = params.append('endDate', endDate.toString());
    }
    params = params.append('pageSize', pageSize.toString());
    params = params.append('page', pageno.toString());
    return this.http.get<any>(this.getRestApiConnection() + '/adminFarmApp/getSoilSampleDetails',{params:params});
  }

  updateEngagementData = (engagementDetails:UpdateEngagementData) =>{
    const req = engagementDetails;
    return this.http.patch<any>(this.getRestApiConnection() + '/adminEngagementSec/updateFarmerData',req);
  }

  
  getEngagementSecData = (engagementType:1|2|3|4,startDate:any,endDate:any,status:string,villageIds?:number[]) =>{
    let params = new HttpParams();
    params = params.append('engagement_section_type', engagementType.toString());
    params = villageIds && villageIds.length>0?params.append('village_id', JSON.stringify(villageIds)):params;
    if(startDate){
      params = params.append('start_date', startDate.toString());
    }
    if(endDate){
      params = params.append('end_date', endDate.toString());
    }
    if(status){
      params = params.append('status', "'"+status.toString()+"'");
    }
    return this.http.get<any>(this.getRestApiConnection() + '/adminEngagementSec/getEngagementSecData',{params:params});
  }

  updateFarmerQualification = (farmerDetails: UpdateFarmerQualification) =>{
    const req = farmerDetails;
    return this.http.patch<any>(this.getRestApiConnection() + '/adminFarmApp/updateFarmerQualification',req);
  }

  getVillageList = () =>{
    return this.http.get<any>(this.getRestApiConnection() + '/adminFarmApp/getVillageList');
  }
  getVillageListByBaseId = (base_id:any) =>{
    let params = new HttpParams();
    params = params.append('base_id', base_id);
    return this.http.get<any>(this.getRestApiConnection() + '/adminFarmApp/getVillageListByBaseId',{params:params});
  }

  getSummaryDashboardData=(startDate:any,endDate:any,villageId:any,baseId:any)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('base_id', baseId);
    params = params.append('village_id', villageId);
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/summary',{params:params});
  }
  getRequiredVillageList = () =>{
    return this.http.get<any>(this.getRestApiConnection() + '/adminFarmApp/getRequiredVillageList');
  }

  getDeploymentSecData=(deploymentType:1|2|3|4|5|6|7,status?:ProgressType,startDate?:number,endDate?:number,villageIds?:number[])=>{
    let params = new HttpParams();
    params = params.append('deployment_section_type', deploymentType.toString());
    params = villageIds && villageIds.length>0?params.append('village_id', JSON.stringify(villageIds)):params;
    if(status){
      params = params.append('status', "'"+status.toString()+"'");
    }
    if(startDate){
      params = params.append('start_date', startDate.toString());
    }
    if(endDate){
      params = params.append('end_date', endDate.toString());
    }
    return this.http.get<any>(this.getRestApiConnection() + '/adminDeploymentSec/getDeploymentSecData',{params:params});
  }

  updateFarmerData = (farmerDetails:UpdateFarmerDeployment) =>{
    const req = farmerDetails;
    return this.http.patch<any>(this.getRestApiConnection() + '/adminDeploymentSec/updateFarmerData',req);
  }

  getFarmerPreSamplingDetails=(farmerDetails:FarmerDetails2)=>{
    const req = farmerDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getFarmerPreSamplingDetails',req);
  }
  getFarmerStartSampleDetails=(farmerDetails:FarmerDetails2)=>{
    const req = farmerDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getFarmerStartSampleDetails',req);
  }
  getFarmerHarvestSampleDetails=(farmerDetails:FarmerDetails2)=>{
    const req = farmerDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getFarmerHarvestSampleDetails',req);
  }
  getFarmeEndYearSampleDetails=(farmerDetails:FarmerDetails2)=>{
    const req = farmerDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getFarmeEndYearSampleDetails',req);
  }
  getFarmeEndThirdYearSampleDetails=(farmerDetails:FarmerDetails2)=>{
    const req = farmerDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getFarmeEndThirdYearSampleDetails',req);
  }
  getFarmeEndFifthYearSampleDetails=(farmerDetails:FarmerDetails2)=>{
    const req = farmerDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getFarmeEndFifthYearSampleDetails',req);
  }

  getDashboardData=(startDate:any,endDate:any,base_id?:any,village_id?:any)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate.toString());
    params = params.append('end_date', endDate.toString());
    base_id?params = params.append('base_id', base_id.toString()):'';
    village_id?params = params.append('village_id', village_id.toString()):'';
    return this.http.get<any>(this.getRestApiConnection() + '/qualitySystemDashboard/dashboardSummary',{params:params});
  }

  getTrailerDetails=(trailerDetails:TrailerDetails)=>{
    const req= trailerDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getTrailerDetails',req);
  }


  getSourceList=()=>{
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/getSourceList');
  }
  getVillageListForWarehouse=()=>{
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/getVillageList');
  }
  getClusterData=(startDate:any,endDate:any,status:Progress,sourceId?:number|null,villageIds?:number[]|null,downloadAs?:number|null)=>{
    let params = new HttpParams();
    params = params.append('startDate', startDate.toString());
    params = params.append('endDate', endDate.toString());
    params = params.append('status', "'"+status.toString()+"'");
    params = villageIds && villageIds.length>0?params.append('village_id', JSON.stringify(villageIds)):params;
    if(sourceId){
      params = params.append('source_id', sourceId.toString());
    }
    if(downloadAs){
      params = params.append('download_as', downloadAs.toString());
    }
    
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/getClusterData',{params:params});
  }

  updateWarehouseApproval=(clusterId:number,villageId:number)=>{
    const req= {
      cluster_id:clusterId,
      village_id:villageId
    }
    return this.http.patch<any>(this.getRestApiConnection() + '/adminWarehouse/updateWarehouseApproval',req);
  }

  
  plotAndDumpingLocation=(clusterIds:number[])=>{
    let params = new HttpParams();
    params = params.append('cluster_ids', JSON.stringify(clusterIds));
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/plotAndDumpingLocation',{params:params});
  }

  updateWarehouseTruck=(verificationDetails:VerificationObjForSource)=>{
    const req= verificationDetails
    return this.http.patch<any>(this.getRestApiConnection() + '/adminWarehouse/updateWarehouseTruck',req);
  }

  deleteGeoJson=(deploymentId:string)=>{
    let params = new HttpParams();
    params = params.append('deployment_id', deploymentId);
    return this.http.get<any>(this.getRestApiConnection() + '/adminDeploymentSec/deleteGeoJson',{params:params});
  }

  uploadGeoJson=(geoJsonData:any)=>{
    const req= geoJsonData
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/uploadGeoJsonData',req);
  }

  confirmPreSamplePlotAndArea=(preSamplePlot:PreSamplePlot)=>{
    const req= preSamplePlot
    return this.http.patch<any>(this.getRestApiConnection() + '/adminDeploymentSec/confirmPlotArea',req);
  }

  updateFarmerDeploymentNOC=(farmerDeploymentNOC:FarmerDeploymentNOC)=>{
    const req= farmerDeploymentNOC
    return this.http.patch<any>(this.getRestApiConnection() + '/adminDeploymentSec/updateFarmerDeploymentNOC',req);
  }
  bulkUpdatePhValues=(soilPHDetails:SoilPHDetails)=>{
    const req= soilPHDetails
    return this.http.patch<any>(this.getRestApiConnection() + '/adminFarmApp/bulkUpdatePhValues',req);
  }
  bulkUpdatePhValues2=(updateBulkFarmerPh:UpdateBulkFarmerPh)=>{
    const req= updateBulkFarmerPh
    return this.http.patch<any>(this.getRestApiConnection() + '/adminFarmApp/bulkUpdatePhValues',req);
  }
  bulkQualifyFarmers=(updateBulkFarmerData:UpdateBulkFarmerData)=>{
    const req= updateBulkFarmerData
    return this.http.patch<any>(this.getRestApiConnection() + '/adminFarmApp/bulkQualifyFarmers',req);
  }

  getClusterDataForVillage=(villageId:number)=>{
    let params = new HttpParams();
    params = params.append('village_id', villageId);
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/getClusterData',{params:params});
  }

  reportFarmerData=(reportData:ReportData)=>{
    const req= reportData;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/reportFarmerData',req);
  }

  getPreviousSectionsLocations=(previousSampleLocation:PreviousSampleLocationObj)=>{
    const req= previousSampleLocation;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getPreviousSectionsLocations',req);
  }


  getWeeklyDeploymentData=(year:number,month:number)=>{
    let params = new HttpParams();
    params = params.append('year', year.toString());
    params = params.append('month', month.toString());
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/getWeeklyDeploymentData',{params:params});
  }

  getDashboardClusterData=(villageId:number)=>{
    let params = new HttpParams();
    params = params.append('village_id', villageId.toString());
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/getClusterData',{params:params});
  }

  getSummary=(startDate:number,endDate:number)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/getSummary',{params:params});
  }
  getFarmerShapeFiles=(farmerDetails:FarmerDetails2)=>{
    const req= farmerDetails;
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/getFarmerShapeFiles',req);
  }

  generateQRCodes=(sectionType:number,qrCounts:number)=>{
    let params = new HttpParams();
    params = params.append('code_section_type', sectionType);
    params = params.append('num_codes', qrCounts);
    return this.http.get<any>(this.getRestApiConnection() + '/adminLabApp/generateQRCodes',{params:params});
  }

  getSampleList=(startDate:any,endDate:any,page:number,pageSize:number,searchId?:string,sampletype?:string[]|null)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('page', page);
    params = params.append('pageSize', pageSize);
    searchId && searchId.length>0?params = params.append('search',searchId):'';
    sampletype && sampletype.length>0?params = params.append('type_search',JSON.stringify(sampletype)):'';
    return this.http.get<any>(this.getRestApiConnection() + '/adminLabApp/getSampleList',{params:params});
  }

  getShipmentList=(startDate:any,endDate:any,page:number,pageSize:number,searchId?:string)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('page', page);
    params = params.append('pageSize', pageSize);
    searchId && searchId.length>0?params = params.append('search',searchId):'';
    return this.http.get<any>(this.getRestApiConnection() + '/adminLabApp/getShipmentList',{params:params});
  }
  
  getCartList=(startDate:any,endDate:any,page:number,pageSize:number,searchId?:string)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('page', page);
    params = params.append('pageSize', pageSize);
    searchId && searchId.length>0?params = params.append('search',searchId):'';
    return this.http.get<any>(this.getRestApiConnection() + '/adminLabApp/getCartList',{params:params});
  }


  getSampleDetailsByID=(sampleId:string)=>{
    let params = new HttpParams();
    params = params.append('sample_id', sampleId);
    return this.http.get<any>(this.getRestApiConnection() + '/adminLabApp/getSampleDetailsByID',{params:params});
  }

  getCartDetailsById=(cartId:string)=>{
    let params = new HttpParams();
    params = params.append('cart_id', cartId);
    return this.http.get<any>(this.getRestApiConnection() + '/adminLabApp/getCartDetails',{params:params});
  }


  getShipmentDetailsByID=(shipmentId:string)=>{
    let params = new HttpParams();
    params = params.append('shipment_id', shipmentId);
    return this.http.get<any>(this.getRestApiConnection() + '/adminLabApp/getShipmentDetailsByID',{params:params});
  }

  getTestList=(sampleId:string)=>{
    let params = new HttpParams();
    params = params.append('sample_id', sampleId);
    return this.http.get<any>(this.getRestApiConnection() + '/adminLabApp/getTestList',{params:params});
  } 

  addTest=(testObj:AddTest)=>{
    const req= testObj;
    return this.http.post<any>(this.getRestApiConnection() + '/adminLabApp/addTest',req);
  }
  getParentSampleIds=(sampleIds:string[])=>{
    const req= {sample_ids:sampleIds};
    return this.http.post<any>(this.getRestApiConnection() + '/adminLabApp/getParentSampleIds',req);
  }


  getSourceData=()=>{
    return this.http.get<any>(this.getRestApiConnection() + '/adminSupplyDemand/getSourceData');
  }
  getAllocationList=(startDate?:number,endDate?:number)=>{
    let params = new HttpParams();
    params = startDate? params.append('start_date', startDate.toString()):params;
    params = endDate? params.append('end_date', endDate.toString()):params;
    return this.http.get<any>(this.getRestApiConnection() + '/adminSupplyDemand/getAllocationList',{params:params});
  }
  sendAllocationReq=(id:number)=>{
    const req= {
      id:id
    };
    return this.http.patch<any>(this.getRestApiConnection() + '/adminSupplyDemand/sendAllocationReq',req);
  }
  allocateMati=(allocateMati:AllocateMatiObj)=>{
    const req= allocateMati;
    return this.http.post<any>(this.getRestApiConnection() + '/adminSupplyDemand/allocateMati',req);
  }
  getSourceVillageDistanceList=(villageId:number,clusterId:number)=>{
    let params = new HttpParams();
    params = params.append('village_id', villageId.toString());
    params = params.append('cluster_id', clusterId.toString());
    return this.http.get<any>(this.getRestApiConnection() + '/adminSupplyDemand/getSourceVillageDistanceList',{params:params});
  }
  addRequestToSource=(requestSource:RequestSource)=>{
    const req= requestSource;
    return this.http.post<any>(this.getRestApiConnection() + '/adminSupplyDemand/addRequestToSource',req);
  }

  getBaseId=()=>{
    return this.http.get<any>(this.getRestApiConnection() + '/adminFarmApp/getBaseId');
  }
  switchBase(currentBaseId:number){
    const req= {
      current_base_id:currentBaseId
    };
    return this.http.patch<any>(this.getRestApiConnection() + '/dashboard/switchBase',req);
  }
  getSummaryData=(startDate:string,endDate:string)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    let currentBase:any = this.cookieService.get('currentBase');
    if(currentBase){
      currentBase = JSON.parse(currentBase);
      const baseId = currentBase.baseId;
      if(baseId){
        params = params.append('base_id', baseId);
      }
    }
    return this.http.get<any>(this.getRestApiConnection2() + '/dashboard/summary',{params:params});
  }

  getFarmerConversation=(startDate:any,endDate:any)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    return this.http.get<any>(this.getRestApiConnection() + '/adminFarmApp/conversationListing',{params:params});
  }

  qcTestDetailListing=(startDate:any,endDate:any,type:'truck_qc'|'source_qc')=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('type', type);
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/qcTestDetailListing',{params:params});
  }
  approveQcReported=(req:QcReport)=>{
    return this.http.patch<any>(this.getRestApiConnection() + '/adminWarehouse/approveQcReported',req);
  }

  dropDownDetailsPlanningDashboard=()=>{
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/dropDownDetailsPlanningDashboard');
  }
  setPlanningDetails=(req:PlanningDetails)=>{
    return this.http.post<any>(this.getRestApiConnection() + '/dashboard/planningDetails',req);
  }
  getPlanningDashboardData=(startDate:number,endDate:number)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/planningDashboardData',{params:params});
  }
  setActualDetails=(req:ActualDetails)=>{
    return this.http.post<any>(this.getRestApiConnection() + '/dashboard/actualDetails',req);
  }
  getActualDashboardData=(startDate:number,endDate:number)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/actualDashboardData',{params:params});
  }
  getClusterRequestDetails=(requestIds:number[])=>{
    let params = new HttpParams();
    params = params.append('request_id', JSON.stringify(requestIds));
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/clusterRequestDetails',{params:params});
  }
  planningVsActualDashboard=(startDate:number,endDate:number,startDate2:number,endDate2:number,villageId:number)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('start_date_for_comparision', startDate2);
    params = params.append('end_date_for_comparision', endDate2);
    params = villageId !=-1?params.append('village_id', villageId):params;
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/planningVsActualDashboard',{params:params});
  }
  defectsNoDefectsListing=(startDate:any,endDate:any,listingType:string,defectType:string|null)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    defectType? params = params.append('defect_type', defectType):'';
    params = params.append('listing_type', listingType);
    return this.http.get<any>(this.getRestApiConnection() + '/qualitySystemDashboard/defectsNoDefectsListing',{params:params});
  }
  getSourceListForQuality=()=>{
    return this.http.get<any>(this.getRestApiConnection() + '/qualitySystemDashboard/sources');
  }
  updateSourceById=(req:UpdateSourceObj)=>{
    return this.http.patch<any>(this.getRestApiConnection() + '/qualitySystemDashboard/source',req);
  }
  uploadCertificate=(req:UploadCertificate)=>{
    return this.http.post<any>(this.getRestApiConnection() + '/qualitySystemDashboard/certificate',req);
  }

  defectsNOC=(defectNoc:DefectNoc)=>{
    return this.http.post<any>(this.getRestApiConnection() + '/qualitySystemDashboard/defectsNOC',defectNoc);
  }

  approvalActionOfNoDefect=(id:number,approval:boolean)=>{
    const req={
      id:id,
      approval:approval
    }
    return this.http.patch<any>(this.getRestApiConnection() + '/qualitySystemDashboard/approvalActionOfNoDefect',req);
  }

  approvalActionOfDefect=(id:number,approval:boolean)=>{
    const req={
      id:id,
      approval:approval
    }
    return this.http.patch<any>(this.getRestApiConnection() + '/qualitySystemDashboard/approvalActionOfDefect',req);
  }
  hseDashboardData=(startDate:any,endDate:any)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    return this.http.get<any>(this.getRestApiConnection() + '/hseSystem/dashboard',{params:params});
  }
  hseReportedListing=(startDate:any,endDate:any)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    return this.http.get<any>(this.getRestApiConnection() + '/hseSystem/reportedListing',{params:params});
  }
  hseReportAction=(id:number,correctiveAction:string)=>{
    const req={
      id:id,
      corrective_action:correctiveAction,
      action:'Closed'
    }
    return this.http.patch<any>(this.getRestApiConnection() + '/hseSystem/reportedAction',req);
  }
  rejectHSE=(id:number,rejectReason:string)=>{
    const req={
      id:id,
      reject_reason:rejectReason
    }
    return this.http.patch<any>(this.getRestApiConnection() + '/hseSystem/rejectAction',req);
  }
  setReportHseCategory=(id:number,category:string)=>{
    const req={
      id:id,
      category:category
    }
    return this.http.patch<any>(this.getRestApiConnection() + '/hseSystem/reportHseCategory',req);
  }

  warehouseDispatchVsDelivery=(startDate:any,endDate:any,source_id:number)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('source_id', source_id);
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/warehouseDispatchVsDelivery/v1',{params:params});
  }

  getDailyWarehouseSummary=(startDate:any,endDate:any)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/dashboardSummary',{params:params});
  }
  getDailySourceDetails=(sourceId:number)=>{
    let params = new HttpParams();
    params = params.append('source_id', sourceId);
    return this.http.get<any>(this.getRestApiConnection() + '/adminWarehouse/dailySourceDetails',{params:params});
  }
  updateCommentOnDeployment=(commentObj:CommentObj)=>{
    return this.http.patch<any>(this.getRestApiConnection() + '/adminDeploymentSec/comment',commentObj);
  }
  defectDetails=(defectId:number)=>{
    let params = new HttpParams();
    params = params.append('id', defectId);
    return this.http.get<any>(this.getRestApiConnection() + '/qualitySystemDashboard/defectDetails',{params:params});
  }
  getVillageSummary=(startDate:any,endDate:any,baseId:any,villageId:any)=>{
    let params = new HttpParams();
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    baseId?params = params.append('base_id', baseId.toString()):'';
    villageId?params = params.append('village_id', villageId.toString()):'';
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/villageSummary/v2',{params:params});
  }
  get24HourDeployments(){
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/latestDeployment/v2');
  }
  get12HourDispatchVsDelivery(){
    return this.http.get<any>(this.getRestApiConnection() + '/dashboard/latestDispatchVsDelivery/v2');
  }
  
  // control fields api
  getControlFieldData=(deploymentSectionType:string,status:string,startDate:any,endDate:any)=>{
    let params = new HttpParams();
    params = params.append('sampleType', deploymentSectionType); 
    params = params.append('status', status); 
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    return this.http.get<any>(this.getRestApiConnection() + '/adminDeploymentSec/v1/getControlFieldData',{params:params});
  }
  getControlFieldMarkers=(farmerId:string)=>{
    let params = new HttpParams();
    params = params.append('farmer_id', farmerId);
    return this.http.get<any>(this.getRestApiConnection() + '/adminDeploymentSec/v1/sample_locations',{params:params});
  }
  reportControlFieldFarmerData=(req:ReportData)=>{
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/reportFarmerData',req);
  }
  updateControlFieldFarmerData=(req:ControlFieldFarmer|ControlFieldUpdateComment)=>{
    return this.http.patch<any>(this.getRestApiConnection() + '/adminDeploymentSec/v1/updateControlFieldFarmerData',req);
  }
  deleteGeoJsonForControlField=(controlFieldId:string)=>{
    let params = new HttpParams();
    params = params.append('control_field_id', controlFieldId);
    return this.http.get<any>(this.getRestApiConnection() + '/adminDeploymentSec/v1/deleteGeoJson',{params:params});
  }
  uploadControlFieldJsonData=(req:ControlFieldJson)=>{
    let params = new HttpParams();
    return this.http.post<any>(this.getRestApiConnection() + '/adminDeploymentSec/v1/uploadControlFieldJsonData',req,{params:params});
  }
  getLabSummary=(userPhoneNo:string,startDate:any,endDate:any,pendingSampleType:string)=>{
    let params = new HttpParams();
    params = params.append('user_phone_no', userPhoneNo);
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('pending_sample_type', pendingSampleType);
    return this.http.get<any>(this.getRestApiConnection3() + '/labApp/sample/v2/getLabsSummary',{params:params});
  }
  getDiscardSummary=(userPhoneNo:string,startDate:any,endDate:any,pendingSampleType:string)=>{
    let params = new HttpParams();
    params = params.append('user_phone_no', userPhoneNo);
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('pending_sample_type', pendingSampleType);
    return this.http.get<any>(this.getRestApiConnection3() + '/labApp/sample/v2/getDiscardedSamples',{params:params});
  }

  getShipmentSummary=(userPhoneNo:string,startDate:any,endDate:any,pendingSampleType:string)=>{
    let params = new HttpParams();
    params = params.append('user_phone_no', userPhoneNo);
    params = params.append('start_date', startDate);
    params = params.append('end_date', endDate);
    params = params.append('pending_sample_type', pendingSampleType);
    return this.http.get<any>(this.getRestApiConnection3() + '/labApp/sample/v2/getShipmentDetails',{params:params});
  }


}